import { combineReducers } from "redux";
import { actions } from "../types";
import { createApiReducer } from "./createApiReducer";


export default combineReducers({
     windowsUpdates: createApiReducer(actions.fetchWindowsUpdates),
})